<div class="ui container" appMargin appPadding paddingB="30">
  <div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div
        fxLayoutAlign="start center"
        fxLayout="row"
        fxLayoutGap="20px"
        (click)="goBack()"
        class="link"
      >
        <div>
          <img src="assets/icons/left-arrow-icon.svg" alt="" />
        </div>
        <div class="equipment-id">
          <!-- Title -->
          <h2 class="ui primary header">{{ messageTemplateId }}</h2>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px">
        <!-- <button class="ui basic small  primary icon button" (click)="goBack()" suiPopup [popupInverted]="true" popupPlacement="bottom" popupText="cancel template creation">
						<i class="trash icon"></i>
						</button> -->
        <button
          class="ui basic small primary button"
          (click)="goBack()"
          suiPopup
          [popupInverted]="true"
          popupPlacement="bottom"
          popupText="cancel template creation"
        >
          Disable
        </button>

        <button
          class="ui small primary button"
          (click)="editMessage()"
          suiPopup
          [popupInverted]="true"
          popupPlacement="bottom"
          popupText="save template"
        >
          Edit Message
        </button>
      </div>
    </div>
    <div class="ui divider" appMargin marginY="3"></div>
    <div *ngIf="success || error">
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="50px">
    <div fxFlex="30%">
      <div class="ui form side-panel" appPadding="15px">
        <div class="field" appMargin marginB="10">
          <label>DESCRIPTION</label>
          {{ template?.messageTemplateDescription }}
        </div>
        <div class="field" appMargin marginB="10">
          <label>EMAIL SUBJECT</label>
          {{ template?.emailSubject ? template.emailSubject : "Nil" }}
        </div>
        <div class="field" appMargin marginB="10">
          <label>SMS SUBJECT</label>
          {{ template?.smsSubject ? template.smsSubject : "Nil" }}
        </div>
        <div class="field" appMargin marginB="10">
          <label>NOTIFICATION SUBJECT</label>
          {{
            template?.notifcationSubject ? template.notifcationSubject : "Nil"
          }}
        </div>
        <div class="field" appMargin marginB="10">
          <label>DATE CREATED</label>
          {{ template?.dateCreated | date }}
        </div>
        <div class="field" appMargin marginB="10">
          <label>CREATED BY</label>
          {{ template?.createdBy }}
        </div>
        <div class="field" appMargin marginB="10">
          <label>LAST EDITED</label>
          {{ template?.dateModified ? (template.dateModified | date) : "Nil" }}
        </div>
        <div class="field" appMargin marginB="10">
          <label>EDITED BY</label>
          {{ template?.modifiedBy ? (template.modifiedBy | createdBy) : "Nil" }}
        </div>
      </div>
    </div>
    <div fxFlex="grow">
      <!-- <div fxLayout="row" fxLayoutAlign='space-between center'> -->
      <div
        class="ui form"
        *ngIf="template"
        [ngClass]="{ loading: pending }"
        [formGroup]="bodies"
      >
        <!-- <i class="ace-icon fa fa-folder-o smaller-90"></i> {{model?.name}} field component -->
        <app-tabset>
          <div class="ui three item menu">
            <a class="item" appTabHeader="1" [isActive]="true">Email</a>
            <a class="item" appTabHeader="2">SMS</a>
            <a class="item" appTabHeader="3">Notification</a>
          </div>
          <div class="ui basic vertical segment" appTabContent="1">
            <editor [init]="option" formControlName="mailTemplate"></editor>
          </div>
          <div class="ui basic vertical segment" appTabContent="2">
            <editor [init]="option" formControlName="smsTemplate"></editor>
          </div>
          <div class="ui basic vertical segment" appTabContent="3">
            <editor
              [init]="option"
              formControlName="notifcationTemlate"
            ></editor>
          </div>
        </app-tabset>
      </div>
      <div class="actions" appMargin marginT="10">
        <div fxLayout="row" fxLayoutGap="30px" fxLayoutAlign="start center">
          <button class="ui basic primary button" (click)="goBack()">
            Discard Changes
          </button>
          <button class="ui primary button" autofocus (click)="update()">
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
